import React from "react";
import {
  useAssetListStore,
  useEditingElementStore,
} from "../../../api/Zustand";
import {
  UseAssetsQuery,
  UseGetTour,
  UseSaveTour,
} from "../../../api/calls/Queries";
import { Popup, TourData } from "../../../Types";
import { useForm } from "react-hook-form";
import { getLanguageFile } from "../../common/GetLanguageFile";
import { SaveButton } from "../RightSidePanel/UiElements";
import FileSelectorButton from "../GuiElements/FileSelectorButton";
import { useQueryClient } from "@tanstack/react-query";

/* eslint import/no-webpack-loader-syntax: off */
// @ts-expect-error
import css from "!raw-loader!./escape-room.css";

const EscapeRoomPopupsEditor = (props: { tourID: number }) => {
  const { setEditingElem, id, goBackTo } = useEditingElementStore();
  const { setOpen } = useAssetListStore();

  const { data: tourData, refetch } = UseGetTour(props.tourID);

  const queryClient = useQueryClient();

  const currentPop = React.useMemo(() => {
    const thisPop = tourData?.popups.find((one) => one.id === id);
    return thisPop;
  }, [tourData, id]);

  const { mutateAsync, isPending } = UseSaveTour();
  const { handleSubmit, register, reset, watch, setValue } = useForm<Popup>();

  React.useEffect(() => {
    if (currentPop?.id) {
      reset(currentPop);
    }
  }, [currentPop, reset]);

  const onSubmit = (data: Popup) => {
    let returnData: Popup;

    if (data.image) {
      returnData = { ...data, type: "image" };
    } else if (data.video) {
      returnData = { ...data, type: "video" };
    } else returnData = { ...data, type: "text" };
    const newTourData = queryClient.setQueryData(["GetTour", props.tourID], {
      ...tourData,
      popups: tourData?.popups.map((pop) =>
        pop.id === currentPop?.id ? { ...returnData } : pop
      ),
    });

    return mutateAsync(newTourData as TourData, { onSuccess: () => refetch() });
  };
  const { data: assetList } = UseAssetsQuery(props.tourID, 2);

  const hasVideo = !!watch("video");
  const hasImage = !!watch("imageID");

  const displayedImageTitle = React.useMemo(() => {
    if (!hasImage) {
      return "NO IMG";
    } else {
      return (
        assetList?.find((one) => one.assetId === currentPop?.imageID)
          ?.assetDescription ?? "ERR"
      );
    }
  }, [assetList, currentPop, hasImage]);

  const isStartingPop = React.useMemo(() => {
    if (tourData?.escapeRoomData?.startPopupID === currentPop?.id) {
      return true;
    } else if (tourData?.escapeRoomData?.endPopupID === currentPop?.id)
      return false;
    else return null;
  }, [currentPop?.id, tourData?.escapeRoomData]);

  const handleImageRemove = () => {
    setValue("imageID", undefined);
    setValue("image", undefined);
    return queryClient.setQueryData(["GetTour", props.tourID], {
      ...tourData,
      popups: tourData?.popups.map((pop) =>
        pop.id === currentPop?.id
          ? { ...pop, image: undefined, imageID: undefined }
          : pop
      ),
    });
  };

  return (
    <>
      <style>{css}</style>
      <div className="right-side-panel-editor">
        <button
          className="back ghost"
          onClick={() => {
            if (goBackTo) {
              setEditingElem("quiz", goBackTo);
            } else setEditingElem("tour", 0);
          }}
        >
          Back
        </button>
        {isStartingPop === true && getLanguageFile("escape_room.start_pop")}
        {isStartingPop === false && getLanguageFile("escape_room.end_pop")}
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>
            {getLanguageFile("right_panel.title")}
            <input type="text" {...register("title")}></input>
          </label>

          <label htmlFor="ao">{getLanguageFile("right_panel.text")}</label>
          <textarea id="ao" {...register("text")}></textarea>
          <div>
            <label>{getLanguageFile("generics.image")}</label>
            <FileSelectorButton
              disabled={hasVideo}
              onClickFunction={() => {
                setOpen(2);
              }}
            >
              {displayedImageTitle}
            </FileSelectorButton>

            {hasImage && (
              <button
                className="round"
                type="button"
                style={{
                  minWidth: "0",
                  fontWeight: "900",
                  border: "none",
                }}
                onClick={handleImageRemove}
              >
                ✖
              </button>
            )}
          </div>

          {getLanguageFile("right_panel.video")}

          <input
            placeholder={getLanguageFile("right_panel.url_placeholder")}
            type="url"
            {...register("video")}
            disabled={hasImage}
          ></input>

          <div>
            <SaveButton
              className="primary"
              disabled={isPending}
              type="submit"
            ></SaveButton>

            <button
              className="secondary"
              type="button"
              onClick={() => {
                reset({ ...defaulStartPopup, id: currentPop?.id });
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EscapeRoomPopupsEditor;

export const defaulStartPopup: Popup = {
  id: "",
  media: undefined,
  image: undefined,
  imageID: undefined,
  imageName: undefined,
  video: undefined,
  title: "sample",
  text: "rules",
  type: "image",
};
